import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { Renderer2 } from '@angular/core';
import {Router} from "@angular/router"
import { AccountService,InstoreService } from '@app/_services';
import { UntypedFormBuilder } from '@angular/forms';
import { first } from 'rxjs/operators';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-campaignlist',
  templateUrl: './campaignlist.component.html',
  styleUrls: ['./campaignlist.component.css']
})
export class CampaignlistComponent implements OnInit {

  
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: ['<span class="fa fa-chevron-left fa-2x"></span>','<span class="fa fa-chevron-right fa-2x"></span>'],
    responsive: {
      0:{
        items:1,
        nav:true
      },
      600:{
          items:3,
          nav:false
      },
      1000:{
          items:5,
          nav:true,
          loop:false
      }

    },
    nav: true
  }

  isCampaignList = 1;

  AssetsDataLists;
  CreativeDataLists;
  festivalLists;
  RegionDataLists;
  ShowroomDataLists;
  CampaignLists:any;
  isLoading = false;

  checkedList:any
  masterSelected:boolean;

  festival_id;
  festival_name;
  s_festivalID :number;
  s_ShowroomID : number;
  s_ShowroomName : string;
  nSubModule = 1; //1-StateWise 2-detail 2-Modify

  constructor(private formBuilder: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef,
    private accountService: AccountService,
    private router: Router,private instoreService: InstoreService,
    private renderer: Renderer2) { }

  ngOnInit(): void {
    this.reloadFestivalLists();
    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadRegionLists();
    this.reloadShowroomLists();
   
  }

  gotoModule(e, path) {
    this.isCampaignList = 0
  }
  selectedHoarding :number;
  imageHoarding :String;

  getCampaignInfo(id,image){
    this.selectedHoarding =id;
    this.imageHoarding = image;
  }

  gotoList() {
    this.isCampaignList = 1;
  }
  onBackClick(){
    if(this.nSubModule == 2) {
       this.nSubModule = 1;
    }else if(this.nSubModule == 1) {
    }else if(this.nSubModule == 3) {
      this.nSubModule = 2;
    }
  }
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadFestivalLists(){
    this.accountService.getFestivalLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.festivalLists = response.result;
        if(response.result.length>0){
            this.s_festivalID = this.festivalLists[0].id;
        }
        console.log("---"+JSON.stringify(this.festivalLists))
        this.festivalLists.map(i=>i.isSelected=false)
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
    
  }
  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
        if(response.result.length>0){
          this.s_ShowroomID = this.ShowroomDataLists[0].id;
          this.s_ShowroomName = this.ShowroomDataLists[0].name;
          this.getCampaignLists();
        }
        
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  selectShowroom(id,name){
    this.s_ShowroomID = id;
    this.s_ShowroomName = name;
    this.getCampaignLists();

  }
  showDetailedView(id,name){
    this.nSubModule = 2;
  }

  // setSelected(id:number){
  //   for (let i = 0; i < this.datahoardingImages.length; i++) {
  //     if(this.datahoardingImages[i].id===id){
  //       if(this.datahoardingImages[i].isSelected){
  //         this.datahoardingImages[i].isSelected = false;
  //       }else{
  //         this.datahoardingImages[i].isSelected = true;
  //       }
  //     }
  //   }
  //   this.getCheckedItemList();
  // }

  // isAllSelected() {
  //   this.masterSelected = this.datahoardingImages.every(function(item:any) {
  //       return item.isSelected == true;
  //     })
  //   this.getCheckedItemList();
  // }

  // getCheckedItemList(){
  //   this.checkedList = [];
  //   for (var i = 0; i < this.datahoardingImages.length; i++) {
  //     if(this.datahoardingImages[i].isSelected)
  //        this.checkedList.push(this.datahoardingImages[i]);
  //   }
  //   console.log(this.masterSelected+"---data----"+JSON.stringify(this.checkedList));
  // }

  clickFestival(CampaignID, CampaignName){
    this.festival_id=CampaignID
    this.festival_name=CampaignName;
    this.s_festivalID = CampaignID;
    this.getCampaignLists();
  }

  getCampaignLists(){
    // console.log(this.s_ShowroomID+"----"+this.s_festivalID)

    this.instoreService.getCampaignLists(this.s_ShowroomID,this.s_festivalID)
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CampaignLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

}




export interface Hoardings {
  region: string ;
  showroom: string ;
  floor: string ;
  location: string ;
  assets_type: string ;
  creative: string ;
  vendor: string ;
  particulars: string ;
  cost: string;
  name:string ;
  width: string;
  height: string ;
  days:number;
}

const HOARDINGS: Hoardings[] = 
[
  {   
        region: "Chennai",
        showroom: "Usman Road",
        floor: "Floor 1",
        location: "Hoarding",
        assets_type: "Blackout Flex",
        creative: "GRT Parking Direction",
        vendor: "",
        particulars: "",
        cost: "",
        name:"Instore 12",
        width: "32.5",
        height: "48.7",days:10
    },
    { 
      region: "Chennai",
      showroom: "Anna Nagar",
      floor: "Floor 3",
      location: "Hoarding",
      assets_type: "Transit Flex",
      creative: "GRT Parking Direction",
      vendor: "",
      particulars: "",
      cost: "",
      name:"Instore 16",
      width: "32.5",
      height: "48.7",days:4
    },
    {  
      region: "Chennai",
        showroom: "Coats Road",
        floor: "Floor1",
        location: "Hoarding",
        assets_type: "Blackout Flex",
        creative: "GRT Parking Direction",
        vendor: "",
        particulars: "",
        cost: "",
        name:"Instore 19",
        width: "32.5",
        height: "48.7",days:5
  },
  {   
    region: "ROTN",
    showroom: "Thiruvallur",
    floor: "Floor1",
    location: "Hoarding",
    assets_type: "Blackout Flex",
    creative: "GRT Parking Direction",
    vendor: "",
    particulars: "",
    cost: "",
    name:"Instore 112",
    width: "32.5",
    height: "48.7",days:3
  },
  { 
    region: "Karnataka",
    showroom: "Jaya Nagar",
    floor: "Floor1",
    location: "Hoarding",
    assets_type: "Blackout Flex",
    creative: "Clear SAV",
    vendor: "",
    particulars: "",
    cost: "",
    name:"Instore 200",
    width: "32.5",
    height: "48.7",days:5
  },
  {  
    region: "Karnataka",
        showroom: "Jaya Nagar",
        floor: "Ground Floor",
        location: "Wall",
        assets_type: "Blackout Flex",
        creative: "Sun Board",
        vendor: "",
        particulars: "",
        cost: "",
        name:"Instore 320",
        width: "32.5",
        height: "48.7",days:8
},{   
  region: "Chennai",
  showroom: "Usman Road",
  floor: "Floor 1",
  location: "Hoarding",
  assets_type: "Blackout Flex",
  creative: "GRT Parking Direction",
  vendor: "",
  particulars: "",
  cost: "",
  name:"Instore 12",
  width: "32.5",
  height: "48.7",days:10
},
{ 
region: "Chennai",
showroom: "Anna Nagar",
floor: "Floor 3",
location: "Hoarding",
assets_type: "Transit Flex",
creative: "GRT Parking Direction",
vendor: "",
particulars: "",
cost: "",
name:"Instore 16",
width: "32.5",
height: "48.7",days:10
},
{  
region: "Chennai",
  showroom: "Coats Road",
  floor: "Floor1",
  location: "Hoarding",
  assets_type: "Blackout Flex",
  creative: "GRT Parking Direction",
  vendor: "",
  particulars: "",
  cost: "",
  name:"Instore 19",
  width: "32.5",
  height: "48.7",days:9
},
{   
region: "ROTN",
showroom: "Thiruvallur",
floor: "Floor1",
location: "Hoarding",
assets_type: "Blackout Flex",
creative: "GRT Parking Direction",
vendor: "",
particulars: "",
cost: "",
name:"Instore 112",
width: "32.5",
height: "48.7",days:1
},
{ 
region: "Karnataka",
showroom: "Jaya Nagar",
floor: "Floor1",
location: "Hoarding",
assets_type: "Blackout Flex",
creative: "Clear SAV",
vendor: "",
particulars: "",
cost: "",
name:"Instore 200",
width: "32.5",
height: "48.7",days:2
},
{  
region: "Karnataka",
  showroom: "Jaya Nagar",
  floor: "Ground Floor",
  location: "Wall",
  assets_type: "Blackout Flex",
  creative: "Sun Board",
  vendor: "",
  particulars: "",
  cost: "",
  name:"Instore 320",
  width: "32.5",
  height: "48.7",days:4
}

];
export interface hoardingImages {
  image: string;
  id:number;
  isExpired:boolean;
  days:number;
  isSelected:boolean;
}
const hoardingImages: hoardingImages[] = [
  { image: '/assets/images/instore/instore1.jpg',id:1,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore2.jpg',id:2,isExpired:true,days:-14,isSelected:false},
  { image: '/assets/images/instore/instore0.jpg',id:3,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore3.jpg',id:4,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore4.jpg',id:5,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore5.jpg',id:6,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore6.jpg',id:7,isExpired:true,days:0,isSelected:false},
  { image: '/assets/images/instore/instore7.jpg',id:8,isExpired:false,days:-10,isSelected:false},
  { image: '/assets/images/instore/instore8.jpg',id:9,isExpired:true,days:-5,isSelected:false}];